Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-stock-tracker-system'),
        wrapper;

    var model = null;

    if ($wrapper.length < 1)
        return;

    var $informationWrapper = $('.information-container', $wrapper);
    var $gridWrapper = $('.grid-container', $wrapper);
    var $gridInventory = $('.grid-inventory', $gridWrapper);
    var $gridMyNetwork = $('.grid-mynetwork', $gridWrapper);

    var datasourceInventory;
    var datasourceMyNetwork;

    wrapper = $wrapper.get(0);

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("StockTrackerSystem", model);
        wrapper.bind(html);
        wrapper.loading(false);
    };

    wrapper.updateGridInventory = function () {
        wrapper.loading(true);
        
        wrapper.loading(false);
    };
    wrapper.updateGridMyNetwork = function () {
        wrapper.loading(true);
        
        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);
        $informationWrapper = $('.information-container', $wrapper);
        $gridWrapper = $('.grid-container', $wrapper);
        $gridInventory = $('.grid-inventory', $gridWrapper);
        $gridMyNetwork = $('.grid-mynetwork', $gridWrapper);
        initTabPanel($wrapper);

        $informationWrapper.on('click', '.confirm-inventory-status .js-submit-button', function (e) {
            wrapper.loading(true);

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.StockTrackerSystem.Messages.ConfirmInventory());
        });
        
        $informationWrapper.on('click', '.undoconfirm-inventory-status .js-submit-button', function (e) {
            wrapper.loading(true);

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.StockTrackerSystem.Messages.UndoConfirmInventory());
        });
    };

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.ConfirmInventorySuccess, wrapper, function (envelope) {
        if ($gridInventory.length > 0) {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.StockTrackerSystem.Messages.GetModel());
        }
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.ConfirmInventoryFailed, wrapper, function (envelope) {
        wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.UndoConfirmInventorySuccess, wrapper, function (envelope) {
        if ($gridInventory.length > 0) {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.StockTrackerSystem.Messages.GetModel());
        }
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.UndoConfirmInventoryFailed, wrapper, function (envelope) {
        wrapper.loading(false);
    });
  
    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.GetModelSuccess, wrapper, function (envelope) {
        model = envelope.message.data.data;
        wrapper.update();

        if ($gridInventory.length > 0) {
            datasourceInventory = new kendo.data.DataSource({
                data: model.Items,
                pageSize: 10,
                sort: [{ field: "CanDelete", dir: "desc" },{ field: "ModelNumber", dir: "asc" }]
            });
            $gridInventory.kendoGrid({
                dataSource: datasourceInventory,
                sortable: true,
                filterable: {
                    mode: "row"
                },
                filter: function (e) {
                    if (e.filter == null) {
                        $('.clear-filters', $gridInventory).addClass("hidden");
                    } else {
                        $('.clear-filters', $gridInventory).removeClass("hidden");
                    }
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    buttonCount: 5
                },
                columns: [
                    { field: "ModelNumber", title: model.Literals.ModelNo },
                    { field: "VinNumber", title: model.Literals.VinNo },
                    { field: "Dealer", title: model.Literals.Dealer },
                    { field: "Location", title: model.Literals.Location },
                    {
                        dataItem: this,
                        headerTemplate: "<center><a href='javascript:void(0)' class='clear-filters hidden'><span class='btn-title'>" + model.Literals.ClearFilters + "</span><span class='icon icon-exit'></span></a></center>",
                        attributes: { class: "text-center" },
                        width: '150px',
                        command: [                            
                            {
                                template: "<a class='btn btn-primary k-grid-btnEdit hidden' title='" + model.Literals.Edit + "'><span class='icon icon-pencil'></span></a>",
                                className: "",
                                name: "btnEdit",
                                dataItem: this,
                                click: function (e) {
                                    e.preventDefault();

                                    var tr = $(e.target).closest("tr");
                                    var data = this.dataItem(tr);

                                    if (!data.WarehouseProductItemId || data.WarehouseProductItemId < 0 || !data.CanDelete) {
                                        kendo.alert("Invalid Action");
                                        return;
                                    }
                                    var $confirmation = $(".x-confirmation-popup.change-partner", $gridWrapper);
                                    var subtitle = $(".subtitle", $confirmation).text() || "";
                                    $(".subtitle", $confirmation).text(subtitle.replace("{0}", data.VinNumber || ""));
                                    $.fancybox.open($confirmation, {
                                        'modal': true,
                                        maxWidth: 900,
                                        padding: 0,
                                        closeClick: false,
                                        beforeShow: function () {                                            

                                            Vendd.MessageBus.publishAsync(wrapper, new Vendd.StockTrackerSystem.Messages.GetSubPartners());

                                            $(".cancel", $confirmation).unbind('click').click(function () {
                                                $.fancybox.close();
                                                $(".subtitle", $confirmation).text(subtitle.replace(data.VinNumber, "{0}"));
                                            });

                                            jQuery(".js-change-partner-btn", $confirmation).unbind('click').click(function () {

                                                wrapper.loading(true);

                                                var partnerId = $(".js-partner-change :selected").val();

                                                if (!data.WarehouseProductItemId || data.WarehouseProductItemId < 0 || !partnerId || partnerId <= 0) {
                                                    kendo.alert("Invalid Action");
                                                    wrapper.loading(false);
                                                }
                                                else {
                                                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.StockTrackerSystem.Messages.ChangePartner(data.VinNumber, partnerId));
                                                }
                                                $.fancybox.close();
                                                $(".subtitle", $confirmation).text(subtitle.replace(data.VinNumber, "{0}"));
                                            });
                                        }
                                    });
                                }
                            },
                            {
                                template: "<a class='btn btn-danger k-grid-btnDelete hidden' style='margin-left:6px;'  title='" + model.Literals.Delete + "'><span class='icon icon-bin'></span></a>",
                                className: "",
                                name: "btnDelete",
                                dataItem: this,
                                click: function (e) {
                                    e.preventDefault();

                                    var tr = $(e.target).closest("tr");
                                    var data = this.dataItem(tr);

                                    if (!data.WarehouseProductItemId || data.WarehouseProductItemId < 0 || !data.CanDelete) {
                                        kendo.alert("Invalid Action");
                                        return;
                                    }
                                    var $confirmation = $(".x-confirmation-popup.remove", $gridWrapper);
                                    var subtitle = $(".subtitle", $confirmation).text() || "";
                                    $(".subtitle", $confirmation).text(subtitle.replace("{0}", data.VinNumber || ""));
                                    $.fancybox.open($confirmation, {
                                        'modal': true,
                                        maxWidth: 900,
                                        padding: 0,
                                        closeClick: false,
                                        beforeShow: function () {
                                            $(".cancel", $confirmation).unbind('click').click(function () {
                                                $.fancybox.close();
                                                $(".subtitle", $confirmation).text(subtitle.replace(data.VinNumber, "{0}"));
                                            });
                                            jQuery(".js-delete-btn", $confirmation).unbind('click').click(function () {
                                                wrapper.loading(true);
                                                if (!data.WarehouseProductItemId || data.WarehouseProductItemId < 0) {
                                                    kendo.alert("Invalid Action");
                                                    wrapper.loading(false);
                                                }
                                                else {
                                                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.StockTrackerSystem.Messages.Remove(data.VinNumber));
                                                }
                                                $.fancybox.close();
                                                $(".subtitle", $confirmation).text(subtitle.replace(data.VinNumber, "{0}"));
                                            });
                                        }
                                    });
                                }
                            }
                        ]
                    }
                ],
                dataBound: function (e) {
                                        
                    var data = this.dataSource.view();

                    for (var i = 0; i < data.length; i++) {
                        var dataItem = data[i];
                        var $tr = $gridInventory.find("[data-uid='" + dataItem.uid + "']");
                       
                        if (!dataItem.CanDelete) {
                            $('.k-grid-btnEdit', $tr).prop('disabled', 'disabled').addClass('disabled').addClass("hidden");
                            $('.k-grid-btnDelete', $tr).prop('disabled', 'disabled').addClass('disabled').addClass("hidden");
                        } else {
                            $('.k-grid-btnEdit', $tr).prop('disabled', '').removeClass('disabled').removeClass('hidden');
                            $('.k-grid-btnDelete', $tr).prop('disabled', '').removeClass('disabled').removeClass('hidden');
                        }
                    }
                }
            });

            $('.clear-filters', $gridInventory).on("click", function () {
                datasourceInventory.filter({});
                datasourceInventory.sort([{ field: "CanDelete", dir: "desc" }, { field: "ModelNumber", dir: "asc" }]);
                $gridInventory.data("kendoGrid").setDataSource(datasourceInventory);
                $('.clear-filters', $gridInventory).addClass("hidden");
            });
        }

        if ($gridMyNetwork.length > 0) {
            datasourceMyNetwork = new kendo.data.DataSource({
                data: model.MyNetworkItems,
                pageSize: 10,
                serverPaging: false,
                serverFiltering: false,
                sort: { field: "Dealer", dir: "asc" }
            });
            $gridMyNetwork.kendoGrid({
                dataSource: datasourceMyNetwork,
                sortable: true,
                filterable: {
                    mode: "row"
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    buttonCount: 5
                },
                columns: [
                    { field: "Dealer", title: model.Literals.Dealer },
                    { field: "Location", title: model.Literals.Location, filterable: false },
                    { field: "LastConfirmation", title: model.Literals.LastConfirmation, filterable: false },
                    { field: "Quantity", title: model.Literals.Quantity, filterable: false },
                    {
                        command: [
                            {
                                template: "<a class='btn btn-primary k-grid-btnView'><span class='btn-title'>" + model.Literals.ViewInventory + "</span><span class='icon icon-arrow-right'></span></a>",
                                className: "",
                                name: "btnView",
                                click: function(e) {
                                    e.preventDefault();

                                    var tr = $(e.target).closest("tr");
                                    var data = this.dataItem(tr);

                                    //if (!data.UserId || data.UserId < 0) {
                                    //    kendo.alert("Invalid Action");
                                    //    return;
                                    //}
                                    //var filterData = _.filter(model.Items, function (i) { return i.UserId == data.UserId; });

                                    if (!data.PartnerId || data.PartnerId < 0) {
                                        kendo.alert("Invalid Action");
                                        return;
                                    }

                                    var filterData = _.filter(model.Items, function (i) { return i.PartnerId === data.PartnerId; });
                                    var datasource = new kendo.data.DataSource({
                                        data: filterData,
                                        pageSize: 10,
                                        sort: [{ field: "CanDelete", dir: "desc" }, { field: "ModelNumber", dir: "asc" }]
                                    });
                                    $gridInventory.data("kendoGrid").setDataSource(datasource);
                                    $('.clear-filters', $gridInventory).removeClass("hidden");
                                    $("[data-tab-index='0']", $wrapper).trigger("click");
                                }
                            }
                        ]
                    }
                ]
            });
        }

    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.GetModelFailed, wrapper, function (envelope) {
        wrapper.loading(false);
    });
    
    Vendd.MessageBus.publishAsync(wrapper, new Vendd.StockTrackerSystem.Messages.GetModel());

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.RemoveSuccess, wrapper, function (envelope) {
        if ($gridInventory.length > 0) {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.StockTrackerSystem.Messages.GetModel());
        }
        //wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.RemoveFailed, wrapper, function (envelope) {
        alert("Cannot find Vin Number");
        wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.GetSubPartnersSuccess, wrapper, function (envelope) {

        var selectList = "";

        envelope.message.data.data.forEach(function (opt) {
            selectList += '<option value="' + opt.PartnerId + '">' + opt.Name + '</option>';
        });

        $('.js-partner-change').html(selectList);    
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.GetSubPartnersFailed, wrapper, function (envelope) {
        alert("Cannot find Partners");
        wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.ChangePartnerSuccess, wrapper, function (envelope) {
        if ($gridInventory.length > 0) {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.StockTrackerSystem.Messages.GetModel());
        }
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.ChangePartnerFailed, wrapper, function (envelope) {
        alert("An error occurred when changing partner!");
        wrapper.loading(false);
    });

});
